import React from 'react';

interface TooltipProps {
    content: string;
    x: number;
    y: number;
    visible: boolean;
}

const styles: { [key: string]: React.CSSProperties } = {
    tooltip: {
        position: 'fixed',
        padding: '8px 12px',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'monospace',
        pointerEvents: 'none',
        zIndex: 9999,
        transition: 'opacity 0.2s ease-in-out',
        whiteSpace: 'pre',
    }
};

export const Tooltip: React.FC<TooltipProps> = ({ content, x, y, visible }) => {
    if (!visible) {
        return null;
    }

    return (
        <div 
            style={{
                ...styles.tooltip,
                left: `${x + 15}px`,
                top: `${y + 15}px`,
                opacity: visible ? 1 : 0,
            }}
            dangerouslySetInnerHTML={{ __html: content }}
        />
    );
}; 